"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FieldError =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(FieldError, _PureComponent);

  function FieldError() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = FieldError.prototype;

  _proto.render = function render() {
    var error = this.props.error; // eslint-disable-next-line

    if (Array.isArray(error)) error = error[0];
    if (!(error instanceof Error)) return null;
    return _react.default.createElement("div", {
      className: (0, _styles.formClass)('error')
    }, error.message);
  };

  return FieldError;
}(_react.PureComponent);

FieldError.propTypes = {
  error: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object])
};
var _default = FieldError;
exports.default = _default;